import styled, { css } from 'styled-components';
import { colors } from '../../../utils/colors';

export const CardKanban = styled.div<{ borderStatus?: string }>`
  background: ${colors.branco};
  border-radius: 7px;
  padding: 10px;
  margin-top: 15px;
  margin-bottom: 15px;
  transition: all 0.3s;

  ${(props) =>
    (props.borderStatus === 'Orçamentos feitos' || props.borderStatus === 'Aprovado') &&
    css`
      border-bottom: 6px solid ${colors.verde10};
    `};
  ${(props) =>
    (props.borderStatus === 'Orçamentos enviados' ||
      props.borderStatus === 'Follow-up' ||
      props.borderStatus === 'Atualizar Orçamentos') &&
    css`
      border-bottom: 6px solid ${colors.cinza};
    `};
  ${(props) =>
    props.borderStatus === 'Recusado' &&
    css`
      border-bottom: 6px solid ${colors.vermelho};
    `};
`;
